// Helpers to derive folder hierarchy from the flat `/folders-dim3/` list.
// Folders nest via `parentFolderId` (null = root); ids may be number or string.

const sameId = (a, b) => String(a) === String(b);

/** Direct child folders of `parentId`. */
export const getChildFolders = (flat = [], parentId) =>
  (flat || []).filter((f) => sameId(f.parentFolderId, parentId));

/** Root folders (no parent, or a parent that isn't in the list). */
export const getRootFolders = (flat = []) => {
  const ids = new Set((flat || []).map((f) => String(f.id)));
  return (flat || []).filter((f) => {
    const p = f.parentFolderId;
    return p === null || p === undefined || p === '' || !ids.has(String(p));
  });
};

/** Total number of nested folders under `folderId` (all depths). */
export const countDescendantFolders = (flat = [], folderId) =>
  getChildFolders(flat, folderId).reduce(
    (sum, child) => sum + 1 + countDescendantFolders(flat, child.id),
    0,
  );

/** Ancestor chain from the root down to (and including) `folderId` — for breadcrumbs. */
export const getFolderPath = (flat = [], folderId) => {
  const byId = new Map((flat || []).map((f) => [String(f.id), f]));
  const path = [];
  const guard = new Set();
  let current = byId.get(String(folderId));
  while (current && !guard.has(String(current.id))) {
    guard.add(String(current.id));
    path.unshift(current);
    const parentId = current.parentFolderId;
    current = parentId !== null && parentId !== undefined ? byId.get(String(parentId)) : null;
  }
  return path;
};

/** True when a folder was auto-created by mirroring a Google Drive folder. */
export const isMirroredFolder = (folder) =>
  folder?.sourceExternalId !== undefined &&
  folder?.sourceExternalId !== null &&
  folder?.sourceExternalId !== '';
